/*!
 * All material copyright ESRI, All Rights Reserved, unless otherwise specified.
 * See https://github.com/Esri/calcite-design-system/blob/dev/LICENSE.md for details.
 * v2.10.1
 */
import { A as ActionMenu, d as defineCustomElement$1 } from './action-menu.js';

const CalciteActionMenu = ActionMenu;
const defineCustomElement = defineCustomElement$1;

export { CalciteActionMenu, defineCustomElement };

//# sourceMappingURL=calcite-action-menu.js.map